import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eb7e313"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view users" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "users__title" }, "Moderators")
], -1))
const _hoisted_3 = { class: "users__utils" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Add moderator ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "person_add", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "users__table"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__table-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "users__table-cell table__email" }, "Email"),
  /*#__PURE__*/_createElementVNode("div", { class: "users__table-cell table__name" }, "First name"),
  /*#__PURE__*/_createElementVNode("div", { class: "users__table-cell table__active" }, "Active")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "users__table-body" }
const _hoisted_11 = { class: "users__table-cell table__email" }
const _hoisted_12 = { class: "users__table-cell table__name" }
const _hoisted_13 = { class: "users__table-cell table__active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "users__add button button--blank",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addModerator()))
      }, _hoisted_6)
    ]),
    (_ctx.moderators)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["users__table-head", { 'users__table-head--dark': _ctx.tableUtilsVisible }])
          }, _hoisted_9, 2),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moderators, (moderator) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "users__table-row",
                key: moderator?.email
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ModeratorDetailsView', params: {id: moderator.externalId} }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(moderator.email), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(moderator.name), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["material-icons", moderator.activated ? 'green' : 'red'])
                  }, _toDisplayString(moderator.activated ? 'check_circle' : 'cancel'), 3)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}